import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/utils/cn'

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  leadingIcon?: ReactNode
  trailingIcon?: ReactNode
  size?: 'sm' | 'md' | 'lg'
  error?: boolean
  wrapperClassName?: string
}

const heights = { sm: 'h-8', md: 'h-10', lg: 'h-12' }

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { leadingIcon, trailingIcon, size = 'md', error, className, wrapperClassName, ...rest },
  ref,
) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 px-3 bg-surface border rounded-md transition-shadow duration-fast',
        'focus-within:shadow-focus',
        error ? 'border-error focus-within:border-error' : 'border-border focus-within:border-accent',
        heights[size],
        wrapperClassName,
      )}
    >
      {leadingIcon && <span className="text-fg-subtle flex">{leadingIcon}</span>}
      <input
        ref={ref}
        className={cn(
          'flex-1 bg-transparent border-none outline-none text-sm text-fg h-full min-w-0 placeholder:text-fg-subtle',
          className,
        )}
        {...rest}
      />
      {trailingIcon && <span className="text-fg-subtle flex">{trailingIcon}</span>}
    </div>
  )
})
